import React from 'react';
import { NumericFormat } from 'react-number-format';

/* Context */
import { VehicleOverviewContext } from 'js/context';

/* Utilities */
import { trans } from 'js/utilities';

export default class FilterOpenInputRange extends React.Component {
    static contextType = VehicleOverviewContext;

    constructor(props) {
        super(props);

        this.updateFilters = () => { };
    }

    componentDidMount() {
        this.updateFilters = this.context.updateFilters;
    }

    render() {
        const { id, filter, path } = this.props;

        return (
            <div className="row gutters-2">
                <div className="col-12">
                    <NumericFormat
                        id={`${id}.selectedMinValue`}
                        className="form-control"
                        value={filter.selectedMinValue}
                        onValueChange={({ floatValue }, { source }) => {
                            if (typeof floatValue !== 'undefined' && source !== 'prop') {
                                this.updateFilters(`${path}.selectedMinValue`, floatValue);
                            }
                        }}
                        decimalSeparator={','}
                        thousandSeparator={'.'}
                        prefix={trans(`sulu.content_block.vehicle_overview.filter.key.${filter.filterKey}.min_prefix`, {}, '')}
                        suffix={trans(`sulu.content_block.vehicle_overview.filter.key.${filter.filterKey}.min_suffix`, {}, '')}
                        fixedDecimalScale={true}
                        decimalScale={0}
                    />
                </div>
                <div className="col-12">
                    <NumericFormat
                        id={`${id}.selectedMaxValue`}
                        className="form-control"
                        value={filter.selectedMaxValue}
                        onValueChange={({ floatValue }, { source }) => {
                            if (typeof floatValue !== 'undefined' && source !== 'prop') {
                                this.updateFilters(`${path}.selectedMaxValue`, floatValue);
                            }
                        }}
                        decimalSeparator={','}
                        thousandSeparator={'.'}
                        prefix={trans(`sulu.content_block.vehicle_overview.filter.key.${filter.filterKey}.max_prefix`, {}, '')}
                        suffix={trans(`sulu.content_block.vehicle_overview.filter.key.${filter.filterKey}.max_suffix`, {}, '')}
                        fixedDecimalScale={true}
                        decimalScale={0}
                    />
                </div>
            </div>
        );
    }
}
